import { useQuery } from "@tanstack/react-query";
import { loginControlApi } from "./axios";
import { ValidateCurrentToken, LogoutSystem } from "../../helpers";
import { AxiosError } from "axios";
import { DataI, ServiceResponseI } from "../../interfaces";
import { LoginControlI, PropsLoginControlI } from "../../interfaces";

const getLoginControls = async ({
  pagination,
  sorting,
  globalFilter,
  dateFrom,
  dateTo,
  success,
}: PropsLoginControlI): Promise<ServiceResponseI<DataI<LoginControlI>>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const params = new URLSearchParams();
    params.append("page", (pagination!.pageIndex + 1).toString());
    params.append("limit", pagination!.pageSize.toString());
    params.append("search", globalFilter ?? "");
    params.append("sorting", JSON.stringify(sorting ?? []));
    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);
    if (success !== undefined) params.append("success", success);

    const { data } = await loginControlApi.get<
      ServiceResponseI<DataI<LoginControlI>>
    >("", {
      params,
      headers: { Authorization: validateToken },
    });

    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};

export const useLoginControls = ({
  pagination,
  sorting,
  globalFilter,
  dateFrom,
  dateTo,
  success,
}: PropsLoginControlI) => {
  const loginControlQuery = useQuery(
    [
      "login-control",
      { pagination, sorting, globalFilter, dateFrom, dateTo, success },
    ],
    () =>
      getLoginControls({
        pagination,
        sorting,
        globalFilter,
        dateFrom,
        dateTo,
        success,
      }),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  );

  return { loginControlQuery };
};
